import React, { useEffect } from 'react'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver'
import ForumIcon from '@material-ui/icons/Forum'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import * as courseUtils from '../../utils/course'
import { useMutation, useQuery, useLazyQuery } from '@apollo/react-hooks'
import { courseMutations } from '../../graphql/mutations/'
import { userQueries, modulesQueries } from '../../graphql/queries/'
import { GET_COURSE_PROGRESS, GET_COURSE } from '../../graphql/queries/courses'
import * as loggerClient from '../../services/loggerClient'
import { examsPropertiesQueries } from '../../graphql/queries'
import FeedbackButtons from './FeedbackButtons'

const useStyles = makeStyles(theme => ({
    supportButton: {
        backgroundColor: '#3B86FF',
        color: '#fff',
        opacity: '1',
        '&:hover': {
            backgroundColor: '#3B86FF'
        }
    },
    skipButton: {
        border: '1px solid',
        padding: '5px 20px',
        fontSize: '14px',
        margin: '0px 8px',
        fontWeight: '400',
        minWidth: '136px',
        '@media (max-width: 1050px)': {
            margin: '0',
            padding: '0',
            border: 'none'
        }
    }
})
)

const ActionsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0px;
`

const CourseInfo = styled.div`
    display: flex;
    flex-wrap: no-wrap;
    align-items: center;
    justify-content: space-between;
    @media(max-width: 1050px) {
        display: none;
    }
`

const CourseNavigation = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    @media(max-width: 1050px) {
        justify-content: space-between;
        min-height: 25px!important;
        height: 25px!important;
    }
`

const ActionButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const TypoDescription = styled(Typography)`
    width: 95%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    direction: ltr;
`

const CourseActionsBar = ({ content, loading, error, trails, conteudoId, cursoId, presentation, progresso }) => {
    const classes = useStyles()


    const [loadModule, { data: dataModule }] = useLazyQuery(modulesQueries.GET_MODULES, { fetchPolicy: "network-only" })

    useEffect(() => {
        loadModule()   
        
          /* if (!presentation) {
            conteudoId && cursoId && adicionaProgresso({
                variables: {
                    conteudoId,
                    cursoId
                }
            })
        }   */
    }, []) // eslint-disable-line

    let forumExist = false

    if (dataModule) {
        const currentCourse = dataModule.modulo.find(item => item.cursos.find(curso => curso === cursoId))
        forumExist = (currentCourse || {}).forum || false
    }

    const updateCache = (cache, { data }) => {
        const { conteudo_id, progresso } = (data || {}).adicionaProgresso
        const queryGET_COURSE_PROGRESS = {
            query: GET_COURSE_PROGRESS,
            variables: {
                curso_id: cursoId
            }
        }

        const queryGET_COURSE = {
            query: GET_COURSE, variables: {
                id: cursoId
            }
        }

        const currentCourseProgress = cache.readQuery(queryGET_COURSE_PROGRESS)
        const currentCourseData = cache.readQuery(queryGET_COURSE)

        const conteudos_concluidos = [...(((currentCourseProgress || {}).progressoCurso || {}).conteudos_concluidos || []).filter(id => id !== conteudo_id)]

        if ((currentCourseData || {}).curso) {
            cache.writeQuery({
                ...queryGET_COURSE,
                data: {
                    ...currentCourseData,
                    curso: {
                        ...currentCourseData.curso,
                        progresso
                    }
                }

            })
        }

        if (!(currentCourseProgress || {}).progressoCurso) {
            cache.writeQuery({
                ...queryGET_COURSE_PROGRESS,
                data: {
                    progressoCurso: {
                        __typename: 'ProgressoCurso',
                        _id: "95873493485734958734987",
                        conteudos_concluidos: [conteudo_id]
                    }
                }
            })
        }
        cache.writeQuery({
            ...queryGET_COURSE_PROGRESS,
            data: {
                ...currentCourseProgress,
                progressoCurso: {
                    ...currentCourseProgress.progressoCurso,
                    conteudos_concluidos: [conteudo_id, ...conteudos_concluidos]
                }
            }
        });
    }

    const [adicionaProgresso] = useMutation(courseMutations.ADD_PROGRESS, {
        update: updateCache
    })
    const history = useHistory()

    const { data: dataUser } = useQuery(userQueries.GET_USER)
    // const { loading: loadingUser, data: dataUser, error: errorUser, refetch: refetchUser } = useQuery()

    const [loadDataInicio, { loading: loadingDataInicio, data: dataInicio }] = useLazyQuery(examsPropertiesQueries.GET_DATE_START, { fetchPolicy: "network-only" })

    useEffect(() => {
        loadDataInicio()
    }, [nextContent]) //eslint-disable-line

    if (loading || error || loadingDataInicio || !dataInicio) return null
    let contents = null
    let nextContent = null
    let prevContent = null
    let firstContent = null

    if ((trails || {}).length) {
        contents = courseUtils.getContentsFromTrails(trails)
    }
    if (contents) {
        firstContent = (contents[0] || {})._id
        nextContent = (contents[courseUtils.getNextContentIdFromContents(contents)(conteudoId)] || {})._id
        prevContent = (contents[courseUtils.getPrevContentIdFromContents(contents)(conteudoId)] || {})._id
    }

    const prevLink = `/curso/${cursoId}/${prevContent}`
    const nextLink = `/curso/${cursoId}/${nextContent}`
    const firstContentLink = `/curso/${cursoId}/${firstContent}`
    const finishLink = `/curso/${cursoId}/concluido`
    const unFinishLink = `/curso/${cursoId}/semconteudo`

    const currentTrailId = (trails || []).reduce((acc, trail) => {
        const find = (trail.items || []).find(trailItem => {
            return (trailItem || {}).conteudos.find(content => {
                return content._id === conteudoId
            })
        })
        if (find && !acc) {
            return (find || {})._id
        } else {
            return acc || null
        }
    }, null)


    const handleNavigation = (contentId, returnDate, progresso) => {

        const origem = cursoId
        const contexto = 'curso'
        const conteudo = content.conteudo_id
        const tipo = (content || {}).subtipo !== null ? (content || {}).subtipo : content.tipo
        const dataHora = parseInt(returnDate.dataInicio, 10)
        const newData = new Date(dataHora).toISOString()

        loggerClient.onShowTestResult({
            conteudo: conteudo,
            tipo: tipo,
            origem: origem,
            contexto: contexto,
            inicio: newData,
            evento: 'visualizacao'
        })

        if (contentId === nextContent) {
            handleNextLink(progresso)
        } else {
            history.push(prevLink)
        }
    }

    const handleNextLink = (progresso) => {
        if (!presentation) {
            conteudoId && cursoId && adicionaProgresso({
                variables: {
                    conteudoId,
                    cursoId
                }
            })
        }
        if (presentation) {
            history.push(firstContentLink)
        } else {
            if ((nextContent) && (progresso < 100)) {
                history.push(nextLink)
            } else if (progresso >= 100) {
                history.push(finishLink)
            } else {
                history.push(unFinishLink)
            }
        }
    }

    return (
        <ActionsWrapper style={{maxHeight: '160px'}}>
            <CourseInfo>
                <div style={{maxWidth: '60%'}}>
                    {(content || {}).titulo && (
                        <Typography gutterBottom variant="body1" component="h2">
                            Título: { (content || {}).titulo}
                        </Typography>
                    )}
                    {(content || {}).descricao && (
                        <TypoDescription gutterBottom variant="body1" component="h2">
                            Descrição: { (content || {}).descricao}
                        </TypoDescription>
                    )}
                    {(content || {}).professor && (
                        <Typography gutterBottom variant="body1" component="h2">
                            Professor: { (content || {}).professor}
                        </Typography>
                    )}
                </div>
                <ActionButtonsWrapper>
                    <FeedbackButtons
                        conteudoId={conteudoId}
                        cursoId={cursoId}
                        trilhaId={currentTrailId}
                    />
                    <Button
                        disabled={!((dataUser || {}).usuario || {}).email}
                        component={'a'}
                        href={`https://atendimento.manole.com.br/aprimora/?e=${btoa(((dataUser || {}).usuario || {}).email)}`}
                        variant="outlined"
                        rel="noopener"
                        target="_blank"
                        style={{ marginRight: '8px' }}
                        className={classes.supportButton}
                        startIcon={<RecordVoiceOverIcon style={{ fontSize: '16px' }} />}
                    >Suporte</Button>

                    {forumExist && (
                        <Button
                            disabled={!currentTrailId}
                            component={RouterLink}
                            variant="outlined"
                            to={`/forum/${cursoId}?categoria=${currentTrailId}`}
                            style={{ marginRight: '8px' }}
                            className={classes.supportButton}
                            startIcon={<ForumIcon style={{ fontSize: '16px' }} />}
                        >Fórum</Button>
                    )}
                </ActionButtonsWrapper>
            </CourseInfo>
            <CourseNavigation>
                {!!presentation && (
                    <>
                        <Button
                            disabled={!firstContentLink}
                            onClick={() => handleNavigation(nextContent, dataInicio)}
                            className={classes.skipButton}
                            color="primary"
                            endIcon={<ArrowForwardIosIcon style={{ fontSize: '14px' }} />}
                        > Ir para aula
                        </Button>
                    </>
                )}
                {prevContent !== null && !!nextContent !== null && !presentation && (
                    <>
                        <Button
                            disabled={!prevContent}
                            color="primary"
                            onClick={() => handleNavigation(prevContent, dataInicio)}
                            className={classes.skipButton}
                            startIcon={<ArrowBackIosIcon style={{ fontSize: '14px' }} />}>
                            Anterior
                        </Button>
                        <Button
                            onClick={() => handleNavigation(nextContent, dataInicio, progresso)}
                            className={classes.skipButton}
                            color="primary"
                            endIcon={<ArrowForwardIosIcon style={{ fontSize: '14px' }} />}
                        > Próximo
                        </Button>
                    </>)}
            </CourseNavigation>
        </ActionsWrapper>
    )
}

export default CourseActionsBar